import { useFlag } from '@unleash/proxy-client-react';

import { FEATURE_UNLEASH_WIRING } from 'constants/features';

export const UnleashWiringTest = () => {
  const enabledFlag = useFlag(FEATURE_UNLEASH_WIRING);
  return <div className="hidden">{`${FEATURE_UNLEASH_WIRING} ${enabledFlag ? 'enabled' : 'disabled'}`}</div>;
};
